import { render, staticRenderFns } from "./EditClass.vue?vue&type=template&id=ea5afd92&"
import script from "./EditClass.vue?vue&type=script&lang=js&"
export * from "./EditClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports